export const BIRTHDAY_MONTH = 7;
export const BIRTHDAY_DAY = 13;

export const birthdayLightingPresets = [
  {
    id: "warm-spotlight",
    label: "Warm Spotlight",
    description: "A bright, generous wash for taking centre stage.",
  },
  {
    id: "blue-hour",
    label: "Blue Hour",
    description: "Quiet, cinematic light for inward scenes and stillness.",
  },
  {
    id: "dress-rehearsal",
    label: "Dress Rehearsal",
    description: "Soft focus, steady breath, room to begin again.",
  },
  {
    id: "golden-encore",
    label: "Golden Encore",
    description: "Sunlit warmth for the roles still waiting for you.",
  },
  {
    id: "velvet-midnight",
    label: "Velvet Midnight",
    description: "Deep theatre shadow with a little daring at the edges.",
  },
];